export enum ActionTypes {
    SET_LOCALE = "SET_LOCALE",
}

export interface II18nState {
    locale: string;
}
